var _defs, _path, _g, _rect, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122 24.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #010101;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #cc2428;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m24.4,21.88V0H0v24.4h122v-2.52H24.4Zm-2.52,0H2.52V2.52h19.35v19.35Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.37,
    y: 3.37,
    width: 5.89,
    height: 5.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 3.37,
    y: 15.14,
    width: 5.89,
    height: 5.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.26,
    y: 9.26,
    width: 5.89,
    height: 5.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.14,
    y: 3.37,
    width: 5.89,
    height: 5.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 15.14,
    y: 15.14,
    width: 5.89,
    height: 5.89
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.38,
    y: 0,
    width: 97.62,
    height: 21.88
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m86.54,4.9c0-.25.14-.39.39-.39h1.91c.2,0,.35.08.47.25l4.72,7.14c.45.68.94,1.4,1.44,2.24.08.14.21.12.21-.04-.02-.8-.06-1.99-.06-2.79v-6.42c0-.25.14-.39.39-.39h1.56c.25,0,.39.14.39.39v12.88c0,.25-.14.39-.39.39h-1.85c-.2,0-.35-.08-.47-.25l-4.78-7.14c-.47-.68-.94-1.4-1.44-2.24-.08-.14-.21-.12-.21.04.02.8.06,1.99.06,2.79v6.42c0,.25-.14.39-.39.39h-1.56c-.25,0-.39-.14-.39-.39V4.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 78.1,
    y: 4.51,
    width: 2.36,
    height: 13.66,
    rx: 0.39,
    ry: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.08,16.2c-.49,0-.92,0-1.17-.08-.27-.08-.43-.23-.59-.47l-1.58-2.34c-.08-.12-.04-.2.1-.25.47-.2.9-.49,1.25-.84.8-.8,1.29-1.99,1.29-3.24s-.47-2.48-1.29-3.28c-.78-.78-1.7-1.19-3.24-1.19h-5.36c-.25,0-.39.14-.39.39v12.88c0,.25.14.39.39.39h1.6c.25,0,.39-.14.39-.39v-4.17c0-.12.08-.2.2-.2h1.99c.25,0,.45.1.59.31l2.22,3.32c.8,1.19,1.58,1.42,2.83,1.42.2,0,.72,0,.9-.06.2-.06.27-.2.27-.37v-1.44c0-.25-.14-.39-.39-.39Zm-3.76-5.66c-.41.37-.86.57-1.6.57h-3.04c-.12,0-.2-.08-.2-.2v-3.9c0-.12.08-.2.2-.2h3.04c.74,0,1.19.2,1.58.57.41.37.62.98.62,1.6,0,.59-.21,1.19-.6,1.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.71,16.84c-.99-.98-1.48-2.22-1.48-4.19v-7.74c0-.25.14-.39.39-.39l1.64.02c.25,0,.39.14.39.39v8.04c0,1.11.29,1.78.86,2.38.55.61,1.44.88,2.32.88s1.83-.27,2.4-.88c.55-.6.82-1.27.82-2.38V4.9c0-.25.14-.39.39-.39h1.64c.25,0,.39.14.39.39v7.84c0,1.95-.49,3.12-1.46,4.12-1.01,1.03-2.58,1.6-4.17,1.6s-3.12-.6-4.12-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.25,5.78c-.86-.84-1.83-1.27-3.49-1.27h-5.62c-.25,0-.39.14-.39.39v12.88c0,.25.14.39.39.39h1.6c.25,0,.39-.14.39-.39v-3.55c0-.12.08-.2.2-.2h3.36c1.68,0,2.71-.43,3.55-1.27.86-.86,1.39-2.13,1.39-3.47s-.51-2.65-1.37-3.51Zm-1.76,5.31c-.45.43-.98.64-1.83.64h-3.34c-.12,0-.2-.08-.2-.2v-4.53c0-.12.08-.2.2-.2h3.34c.86,0,1.39.23,1.83.64.47.43.7,1.13.7,1.83s-.23,1.37-.7,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m115.79,17.72l-5.35-12.91c-.08-.21-.23-.29-.45-.29h-2.03c-.21,0-.37.12-.45.31l-5.29,12.9c-.12.27.02.45.31.45h1.72c.21,0,.37-.12.45-.31l1.03-2.56c.06-.16.16-.21.31-.21h5.85c.16,0,.25.06.31.21l1.05,2.56c.08.2.23.31.45.31h1.78c.29,0,.41-.18.29-.45Zm-4.86-4.92h-3.92c-.18,0-.27-.1-.2-.27l.88-2.28c.39-1,.74-1.91,1.13-2.95.08-.21.2-.21.27,0,.39,1.03.74,1.95,1.13,2.95l.88,2.28c.08.18,0,.27-.18.27Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m116.04,3.5c-1.24,0-2.23,1-2.23,2.23s.99,2.23,2.23,2.23,2.23-1,2.23-2.23-1-2.23-2.23-2.23Zm0,4.09c-1.02,0-1.84-.86-1.84-1.86s.82-1.84,1.84-1.84,1.86.82,1.86,1.84-.84,1.86-1.86,1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m116.75,6.42l-.27-.4c.33-.11.51-.42.51-.73,0-.42-.29-.77-.8-.77h-.99v2.37h.42v-.82h.4l.42.62c.18.27.31.27.64.24v-.38c-.18,0-.22.02-.33-.13Zm-.58-.75h-.55v-.75h.55c.18,0,.38.09.38.38,0,.27-.18.38-.38.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.4fa48ace6102edb0449bc25f10eaf704.svg";
export { ForwardRef as ReactComponent };